export const analisysTypesReducer = (state = {loading: true, resultAnalisysType: null, analisysTypes: null, initialBalance: null, analisysType: null } , action) => {
    switch (action.type) {
        case 'ANALISYSTYPE_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                analisysTypes: action.payload.analisysTypes
            }
        case 'ANALISYSTYPE_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                analisysType: action.payload
            }
        case 'ANALISYSTYPE_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                analisysTypes: [...state.analisysTypes, action.payload.analisysType],
                resultAnalisysType: action.payload.message
            }
        case 'ANALISYSTYPE_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                analisysTypes: state.analisysTypes.map(analisysType => analisysType._id === action.payload.analisysType._id ? action.payload.analisysType : analisysType),
                resultAnalisysType: action.payload.message
            }
        case 'ANALISYSTYPE_REMOVE_RESULT':
            return {
                ...state,
                loading:false,
                resultAnalisysType: action.payload.message,
                analisysTypes: state.analisysTypes.filter(analisysTypes => analisysTypes._id !== action.payload.analisysType)
            }
        case 'ANALISYSTYPE_RESET_RESULT':
            return {...state,
                resultAnalisysType: null
            }
        case 'ANALISYSTYPE_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'ANALISYSTYPE_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'ANALISYSTYPES_RESET':
            return {
                ...state,
                analisysTypes: null
        }
        default:
            return state
    }
}

